import QOption from '../select/src/option';

export default QOption;
